import { useQuery, useQueryClient } from '@tanstack/react-query'
import { useCallback } from 'react'

import { apiClient } from '../../apiClient'

export const PROGRAM_INSTANCE_COMMON_MISTAKES_KEY = 'program-instance-common-mistakes'

export type ProgramInstanceCommonMistakesRequest = {
  programInstanceId?: string
  startDate?: string
  endDate?: string
}

export type ProgramInstanceCommonMistakesResponse = {
  response: {
    correct: string
    wrong: string
    type: 'object_detection' | 'classification' | 'response'
    subType: string | null
  }
  count: number
  countTrend: number | null
  share: number
  shareTrend: number | null
  partOfCurrentSuspension: boolean
}

export async function fetchProgramInstanceCommonMistakes({
  programInstanceId,
  startDate,
  endDate,
}: ProgramInstanceCommonMistakesRequest) {
  const response = await apiClient.get<ProgramInstanceCommonMistakesResponse[]>(
    `/int/v3/operators/program-instances/${programInstanceId}/common-mistakes/mine`,
    {
      params: { startDate, endDate },
    }
  )

  return response.data
}

export function useGetMineCommonMistakesByProgramInstance(params: ProgramInstanceCommonMistakesRequest) {
  return useQuery({
    queryKey: [
      PROGRAM_INSTANCE_COMMON_MISTAKES_KEY,
      params.programInstanceId,
      params.startDate,
      params.endDate,
    ],
    queryFn: () => fetchProgramInstanceCommonMistakes(params),
    enabled: Boolean(params.programInstanceId) && Boolean(params.startDate) && Boolean(params.endDate),
    refetchOnWindowFocus: false,
  })
}

export function useInvalidateMineCommonMistakesByProgramInstance() {
  const queryClient = useQueryClient()
  return useCallback(
    () => queryClient.invalidateQueries({ queryKey: [PROGRAM_INSTANCE_COMMON_MISTAKES_KEY] }),
    [queryClient]
  )
}
